import styled, { keyframes } from "styled-components";
import { colors } from "definitions";
import { Button as PrimaryButton } from "basics/buttons";

/* El cuadro va adentro de `components/Modal`, que ya pone borde, radio,
   sombra y fondo: acá sólo se define el ancho y el layout interno. */
export const Card = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 42rem;
  max-width: 100%;
  padding: 3.2rem 3.2rem 2.8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  width: 3.2rem;
  height: 3.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;

  svg {
    width: 1.4rem;
    height: 1.4rem;
    fill: currentColor;
  }

  :hover {
    background-color: #eef2f7;
    color: ${colors.fonts.darkGray};
  }

  :focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 110, 223, 0.35);
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  /* Deja lugar a la X para que un título largo no se le meta debajo. */
  padding-right: 3.2rem;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 2.8rem;
  color: ${colors.fonts.darkGray};
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 1.4rem;
  line-height: 2rem;
  color: #64748b;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const Label = styled.label`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${colors.fonts.darkGray};
`;

export const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  min-height: 4.4rem;
  padding: 0 1.4rem;
  font-family: inherit;
  font-size: 1.5rem;
  color: ${colors.fonts.darkGray};
  background: white;
  border: 1px solid #c9d4e4;
  border-radius: 8px;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;

  ::placeholder {
    color: #94a3b8;
  }

  :hover {
    border-color: #94a3b8;
  }

  :focus {
    border-color: ${colors.background.yellowGreen};
    box-shadow: 0 0 0 3px rgba(0, 110, 223, 0.18);
  }

  &[aria-invalid="true"] {
    border-color: ${colors.fonts.red};
  }
`;

export const SubmitButton = styled(PrimaryButton)`
  width: 100%;
  min-height: 4.4rem;
  font-size: 1.5rem;
`;

/* --- Estados de envío y espera ------------------------------------------ */

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.8rem;
  padding: 1.2rem 0 0.4rem;
`;

export const StatusIcon = styled.div`
  width: 5.6rem;
  height: 5.6rem;
  margin-bottom: 0.8rem;
  border-radius: 50%;
  background: rgba(0, 110, 223, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 2.8rem;
    height: 2.8rem;
    stroke: ${colors.background.yellowGreen};
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export const StatusTitle = styled(Title)`
  font-size: 2rem;
`;

export const StatusText = styled(Subtitle)`
  strong {
    color: ${colors.fonts.darkGray};
    font-weight: 600;
    word-break: break-all;
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 3.6rem;
  height: 3.6rem;
  margin-bottom: 0.8rem;
  border: 3px solid rgba(0, 110, 223, 0.15);
  border-top-color: ${colors.background.yellowGreen};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;
